module.exports = __webpack_public_path__ + "img/SAVA.069d6bba.png";